import { BlockNoteEditor, Block, BlockSchema } from '@blocknote/core';
import { useState } from 'react';
import { ModalVariant } from 'types/Modal';
import { useModalService } from './useModalService';

interface UseBlockDeleteProps<T extends BlockSchema> {
  editor: BlockNoteEditor<T, any, any>;
  block: Block<any, any, any>;
  name: string;
}

interface UseBlockDeleteReturn {
  isDeleting: boolean;
  handleDelete: () => void;
}

export const useBlockDelete = <T extends BlockSchema>({
  editor,
  block,
  name,
}: UseBlockDeleteProps<T>): UseBlockDeleteReturn => {
  const [isDeleting, setIsDeleting] = useState(false);
  const modalService = useModalService();

  const handleDelete = (): void => {
    setIsDeleting(true);
    modalService.show(ModalVariant.WORKSHEET_DELETE_BLOCK, {
      name,
      onAccept: () => {
        editor.removeBlocks([block]);
        setIsDeleting(false);
      },
      onCancel: () => {
        setIsDeleting(false);
      },
    });
  };

  return {
    isDeleting,
    handleDelete,
  };
};
